import { TFunction } from '@wix/yoshi-flow-editor';
import { LAST_CATEGORY_ID_FOR_MIGRATION } from '../constants/migration';
import { toNumber } from 'lodash';

export const getCategoryTitleForOOI = (
  categoryId: string,
  index: number,
  categoryTitle: string,
  t: TFunction,
  createdDate?: Date | null,
  updatedDate?: Date | null,
): string => {
  const categoryIdSuffix = categoryId.slice(-5);
  const isMigratingCategory =
    LAST_CATEGORY_ID_FOR_MIGRATION.includes(categoryIdSuffix);
  const isMigratedName = categoryTitle?.toLowerCase().startsWith('comp-');
  const isEmptyCategory = !categoryTitle || categoryTitle.trim() === '';
  const isTimeDifferenceLessThan3Hours =
    updatedDate &&
    createdDate &&
    Math.abs(+new Date(updatedDate) - +new Date(createdDate)) / 36e5 <= 3;

  if (
    isMigratingCategory &&
    (isMigratedName || isEmptyCategory || isTimeDifferenceLessThan3Hours)
  ) {
    return `${t('display.tab.categories.general')}${toNumber(index + 1)}`;
  }
  return categoryTitle || '';
};
